const courses = [
  {
    id: 1,
    title: "Comportamento do Consumidor",
    desc: "Entenda como seu cliente pensa, decide e compra — e use isso a seu favor.",
    icon: "ri-brain-line",
    bg: "bg-[#1a1a1a]",
    tag: "Módulo 01",
  },
  {
    id: 2,
    title: "Venda Mais por WhatsApp",
    desc: "Técnicas práticas para transformar conversas em vendas todos os dias.",
    icon: "ri-whatsapp-line",
    bg: "bg-[#2d2017]",
    tag: "Módulo 02",
  },
  {
    id: 3,
    title: "Domine as Ferramentas de IA",
    desc: "Aplique inteligência artificial no seu negócio e ganhe tempo e resultado.",
    icon: "ri-sparkling-2-line",
    bg: "bg-[#111827]",
    tag: "Módulo 03",
  },
  {
    id: 4,
    title: "Venda pelo TikTok",
    desc: "Como criar conteúdo que vende e construir audiência que compra de você.",
    icon: "ri-tiktok-line",
    bg: "bg-[#1a0a1a]",
    tag: "Módulo 04",
  },
];

export default function DesignerSpotlight() {
  return (
    <section className="py-20 px-6 md:px-16 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <p className="text-xs tracking-[0.3em] uppercase text-gray-400 mb-2">Clientizah — Gleice Lyra</p>
          <h2 className="text-3xl font-light tracking-tight text-black">Destaque para as aulas online</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {courses.map((course) => (
            <div
              key={course.id}
              className={`${course.bg} group cursor-pointer p-8 flex flex-col justify-between min-h-[280px] hover:opacity-90 transition-opacity`}
            >
              <div>
                <div className="w-10 h-10 flex items-center justify-center mb-6">
                  <i className={`${course.icon} text-white/60 text-2xl`}></i>
                </div>
                <p className="text-[10px] tracking-[0.25em] uppercase text-white/30 mb-3">{course.tag}</p>
                <h3 className="text-white text-lg font-light leading-snug tracking-tight mb-4">
                  {course.title}
                </h3>
                <p className="text-white/50 text-xs leading-relaxed">
                  {course.desc}
                </p>
              </div>
              <div className="mt-8">
                <span className="text-[10px] tracking-widest uppercase text-white/30 border-b border-white/20 pb-1 group-hover:text-white/60 group-hover:border-white/40 transition">
                  Ver aula
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}